<template>
  <v-container>
    <v-row>
      <v-expansion-panels flat class="card" focusable hover mandatory>
        <v-expansion-panel v-for="asignacion in asignacionesEquipo" :key="asignacion.id">
          <v-expansion-panel-header>
            <div>
              <div class="text-h6 secondary--text font-weight-bold d-inline">
                {{ asignacion.fechaAsignacion }}
              </div>
              <div class="text-overline d-inline secondary--text">({{ asignacion.equipoAsignado.length }})</div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-container>
              <v-row>
                <v-col cols="12" lg="4" xl="3" v-for="item in asignacion.equipoAsignado" :key="item.id">
                  <v-card class="card" color="secondary" elevation="8">
                    <v-card-title>
                      <v-container>
                        <v-row>
                          <v-col cols="12" align="center">
                            <v-avatar rounded color="primary" size="80">
                              <v-icon x-large color="secondary">mdi-briefcase</v-icon>
                            </v-avatar>
                          </v-col>
                          <v-col cols="12" align="center">
                            <div class="text-h6 primary--text font-weight-bold">{{ item.CatItem.item }}</div>
                            <div class="text-subtitle-1 primary--text">{{ item.numero }}</div>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="8">
                            <div class="text-subtitle-1 primary--text">Fecha de fabricación:</div>
                          </v-col>
                          <v-col cols="4">
                            <div class="text-subtitle-1 font-weight-bold primary--text">
                              {{ item.fechaFabricacion }}
                            </div>
                          </v-col>
                          <v-col cols="8">
                            <div class="text-subtitle-1 primary--text">Vigencia de equipo hasta:</div>
                          </v-col>
                          <v-col cols="4">
                            <div class="text-subtitle-1 font-weight-bold primary--text">
                              {{ item.aniosVigencia }}
                            </div>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
  </v-container>
</template>
<script>
import { cardProps, cardFormColsProps, cardTitleProps, textInputProps } from '../../components/props/props'
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'

export default {
  props: {
    id: {
      type: Number,
    },
  },

  async mounted() {
    await this.fetchAsignacionEquipoByPersonal(this.id)
  },

  data() {
    return {
      cardProps,
      cardTitleProps,
      cardFormColsProps,
      textInputProps,

      searchAsignacion: '',
      buscaItem: '',
      selectedDate: 0,
      ordenAlfabetico: 0,
    }
  },

  computed: {
    ...mapGetters('asignacionEquipo', {
      asignacionesEquipo: 'getAsignacionesEquipo',
    }),
  },

  methods: {
    ...mapActions('asignacionEquipo', ['fetchAsignacionEquipoByPersonal']),
  },
}
</script>

<style scoped>
/* Estilos modernos para Equipo Asignado */
.card {
  background: rgba(46, 36, 22, 0.6) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 159, 67, 0.2);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  animation: fadeInUp 0.6s ease-out;
}

.card:hover {
  transform: translateY(-4px);
  border-color: rgba(255, 159, 67, 0.4);
  box-shadow: 0 12px 48px rgba(255, 159, 67, 0.3);
}

/* Expansion panels */
::v-deep .v-expansion-panels {
  background: transparent !important;
}

::v-deep .v-expansion-panel {
  background: rgba(46, 36, 22, 0.6) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 159, 67, 0.2);
  border-radius: 16px !important;
  margin-bottom: 16px;
  transition: all 0.3s ease;
}

::v-deep .v-expansion-panel:hover {
  border-color: rgba(255, 159, 67, 0.4);
  box-shadow: 0 8px 24px rgba(255, 159, 67, 0.2);
}

::v-deep .v-expansion-panel--active {
  border-color: rgba(255, 159, 67, 0.5);
  box-shadow: 0 12px 32px rgba(255, 159, 67, 0.3);
}

::v-deep .v-expansion-panel-header {
  background: rgba(255, 159, 67, 0.08) !important;
  color: #e0e0e0 !important;
  border-radius: 16px 16px 0 0;
  padding: 20px 24px;
  transition: all 0.3s ease;
}

::v-deep .v-expansion-panel-header:hover {
  background: rgba(255, 159, 67, 0.12) !important;
}

::v-deep .v-expansion-panel-content {
  background: transparent !important;
}

::v-deep .v-expansion-panel-content__wrap {
  padding: 24px;
}

/* Títulos */
.text-h6 {
  color: #ffbe76 !important;
  font-weight: 700 !important;
  letter-spacing: 0.5px;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.text-overline {
  color: rgba(255, 190, 118, 0.7) !important;
}

.text-subtitle-1 {
  color: rgba(224, 224, 224, 0.85) !important;
}

.font-weight-bold {
  color: #ff9f43 !important;
}

/* Cards de equipo individuales */
::v-deep .v-card.card.secondary {
  background: rgba(46, 36, 22, 0.8) !important;
  border: 1px solid rgba(255, 159, 67, 0.3);
}

::v-deep .v-card.card.secondary:hover {
  transform: translateY(-8px);
  box-shadow: 0 16px 48px rgba(255, 159, 67, 0.4);
}

/* Avatares */
::v-deep .v-avatar {
  background: rgba(255, 159, 67, 0.15) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 159, 67, 0.3);
  transition: all 0.3s ease;
}

::v-deep .v-avatar:hover {
  transform: scale(1.1) rotate(5deg);
  border-color: #ff9f43;
  box-shadow: 0 8px 24px rgba(255, 159, 67, 0.4);
}

::v-deep .v-avatar .v-icon {
  color: #ffbe76 !important;
  filter: drop-shadow(0 4px 12px rgba(255, 159, 67, 0.4));
}

/* Card title */
::v-deep .v-card-title {
  padding: 24px !important;
}

/* Card text */
::v-deep .v-card-text {
  padding: 20px !important;
}

/* Colores para texto en cards secundarios */
::v-deep .v-card.secondary .primary--text {
  color: #e0e0e0 !important;
}

::v-deep .v-card.secondary .text-h6.primary--text {
  color: #ffbe76 !important;
  font-weight: 700;
}

::v-deep .v-card.secondary .text-subtitle-1.primary--text {
  color: rgba(224, 224, 224, 0.85) !important;
}

::v-deep .v-card.secondary .font-weight-bold.primary--text {
  color: #ff9f43 !important;
}

/* Contenedores */
::v-deep .v-container {
  padding: 16px;
}

/* Rows */
::v-deep .v-row {
  margin: -8px;
}

::v-deep .v-col {
  padding: 8px;
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(255, 159, 67, 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 159, 67, 0.6);
}

/* Animación */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
